<template>
  <div>
    <div class="step-header">
      <small>Etapa 4 de 5</small>
      <h5>Informações econômicas</h5>
      <small>Atenção: TODAS as perguntas são obrigatórias.</small>
    </div>

    <label>Você possui veículo?</label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="possuiVeiculo"
          :value="'Sim'"
          v-on:change="updateValue($event, 'possuiVeiculo')"
        />
        <i class="helper" style="top: 3px;"></i>Sim
      </label>
      <label>
        <input
          type="radio"
          v-model="possuiVeiculo"
          :value="'Não'"
          v-on:change="updateValue($event, 'possuiVeiculo')"
        />
        <i class="helper" style="top: 3px;"></i>Não
      </label>
    </div>

    <label>Você tem disponibilidade de capital para investimento?</label>
    <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
      <label>
        <input
          type="radio"
          v-model="capitalParaInvestimento"
          :value="'Sim, e c/c ou espécie'"
          v-on:change="updateValue($event, 'capitalParaInvestimento')"
        />
        <i class="helper" style="top: 3px;"></i>Sim, e c/c ou espécie
      </label>
      <label>
        <input
          type="radio"
          v-model="capitalParaInvestimento"
          :value="'Sim, aplicação'"
          v-on:change="updateValue($event, 'capitalParaInvestimento')"
        />
        <i class="helper" style="top: 3px;"></i>Sim, aplicação
      </label>
      <label>
        <input
          type="radio"
          v-model="capitalParaInvestimento"
          :value="'Não, dependo da venda de imóvel/veículo'"
          v-on:change="updateValue($event, 'capitalParaInvestimento')"
        />
        <i class="helper" style="top: 3px;"></i>Não, dependo da venda de
        imóvel/veículo
      </label>
      <label>
        <input
          type="radio"
          v-model="capitalParaInvestimento"
          :value="'Não, dependo de emprestimo bancário'"
          v-on:change="updateValue($event, 'capitalParaInvestimento')"
        />
        <i class="helper" style="top: 3px;"></i>Não, dependo de emprestimo
        bancário
      </label>
      <label>
        <input
          type="radio"
          v-model="capitalParaInvestimento"
          :value="'Não, outros'"
          v-on:change="updateValue($event, 'capitalParaInvestimento')"
        />
        <i class="helper" style="top: 3px;"></i>Não, outros
      </label>
    </div>

    <b-form-group class="w-100 mt-1" v-if="capitalParaInvestimento === 'Não, outros'">
      <input
        type="text"
        :value="capitalInvestimento"
        required="required"
        v-on:change="updateValue($event, 'capitalInvestimento')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Especifique</label>
      <i class="bar"></i>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ["possuiVeiculo", "capitalParaInvestimento", "capitalInvestimento"],
  methods: {
    updateValue(event, data) {
      this.$emit(`update:${data}`, event.target.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-header {
  margin-bottom: 30px;
}
</style>